import { FileUpload, UseStepContext } from '@consigli/facade';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { WizardAnalyzeButton } from './wizard-analyze-button';
import { WizardBackButton } from './wizard-back-button';

interface UserUploadProps {
  localFiles: File[];
  setLocalFiles: Dispatch<SetStateAction<File[]>>;
  useStepContext: UseStepContext;
  onAnalyze: () => void;
  disabled?: boolean;
  maxFileSizeBytes?: number;
  fileSizeWarningText?: string;
}

export const UserUpload = ({
  localFiles,
  setLocalFiles,
  useStepContext,
  onAnalyze,
  disabled = false,
  maxFileSizeBytes,
  fileSizeWarningText,
}: UserUploadProps) => {
  const { t } = useTranslation();

  return (
    <FileUpload
      files={localFiles}
      setFiles={setLocalFiles}
      dropAreaLabel={t('document-upload.drag-n-drop-here')}
      dropAreaClassName="mt-4 h-48 w-full"
      fileButtonLabel={t('document-upload.browse-files')}
      folderButtonLabel={t('document-upload.browse-folders')}
      heading={t('package-creation.upload-files')}
      uploadListLabel={t('document-upload.files')}
      zeroByteFilesMessage={t('document-upload.file-zero-bytes')}
      maxFileSizeBytes={maxFileSizeBytes}
      fileSizeWarningText={fileSizeWarningText}
    >
      <div className="fc-grid fc-grid-cols-2 fc-gap-4 fc-w-fit">
        <WizardBackButton context={useStepContext} />
        <WizardAnalyzeButton
          localFiles={localFiles}
          onAnalyze={onAnalyze}
          disabled={disabled}
        ></WizardAnalyzeButton>
      </div>
    </FileUpload>
  );
};
